// src/universal/hooks/useSubscription/helpers.ts
var SubscriptionErrorType = /* @__PURE__ */ ((SubscriptionErrorType2) => {
  SubscriptionErrorType2["AUTHENTICATION_FAILED"] = "AUTHENTICATION_FAILED";
  SubscriptionErrorType2["CONNECTION_INIT_FAILED"] = "CONNECTION_INIT_FAILED";
  SubscriptionErrorType2["CONNECTION_CLOSED"] = "CONNECTION_CLOSED";
  SubscriptionErrorType2["CLEANUP_ERROR"] = "CLEANUP_ERROR";
  SubscriptionErrorType2["SUBSCRIPTION_START_FAILED"] = "SUBSCRIPTION_START_FAILED";
  SubscriptionErrorType2["DATA_PARSING_ERROR"] = "DATA_PARSING_ERROR";
  SubscriptionErrorType2["NETWORK_ERROR"] = "NETWORK_ERROR";
  SubscriptionErrorType2["SERVER_ERROR"] = "SERVER_ERROR";
  return SubscriptionErrorType2;
})(SubscriptionErrorType || {});
var createExponentialBackoff = (params) => {
  const { maxRetries = 3, baseDelay = 1e3, maxDelay = 5e3 } = params || {};
  let retryCount = 0;
  return {
    shouldRetry: () => retryCount < maxRetries,
    getNextDelay: () => {
      const delay = Math.min(maxDelay, baseDelay * Math.pow(2, retryCount) * (1 + Math.random()));
      retryCount++;
      return delay;
    },
    reset: () => {
      retryCount = 0;
    }
  };
};

export { SubscriptionErrorType, createExponentialBackoff };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-WDGAR7LI.mjs.map